import styled from 'styled-components'
import { black, mutedGrey, grey } from '@/theme/colors'
import { radii, media, motion } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Dropdown } from '@components/Dropdown'
import { Pill } from '@components/Pill'

export const FilterRow = styled.div`
	display: flex;
	justify-content: flex-start;
	gap: 12px;
	flex-wrap: wrap;
	margin-bottom: 20px;
`

/** Content-sized in the filter row, never narrower than a comfortable label; a full row each on a phone. */
export const FilterDropdown = styled(Dropdown)`
	min-width: 220px;
	max-width: 100%;

	${media.phone} {
		min-width: 0;
		flex-basis: 100%;
	}
` as typeof Dropdown

export const IdeasGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 16px;

	${media.phone} {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}

	${media.aboveTablet} {
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	}

	${media.wide} {
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	}
`

/** Bare tile — no card chrome, just the rounded image with the name below. */
export const IdeaTile = styled.button`
	display: block;
	width: 100%;
	padding: 0;
	border: none;
	background: transparent;
	text-align: left;
	font: inherit;
	cursor: pointer;

	&:hover img,
	&:focus-visible img {
		transform: scale(1.03);
	}
`

/** Square rounded image; ideas without a link preview show a centered icon. */
export const IdeaThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	border-radius: ${radii.inner};
	background: ${grey};
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${mutedGrey};

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform ${motion.base};
	}
`

export const IdeaName = styled.div`
	padding: 8px 2px 0;
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${black};
	/* Two lines then ellipsis, like the iOS tile title. */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`

export const AttachmentBadge = styled(Pill).attrs({ $tone: 'dark' as const })`
	position: absolute;
	top: 8px;
	right: 8px;
	gap: 4px;
`

/** Positioning context for the attachment badge. */
export const ThumbnailFrame = styled.div`
	position: relative;
`
